import jsPDF from "jspdf";

import html2canvas from "html2canvas";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import "./Css/PrintEqunry.css";
// ForwardRef to pass the ref from parent to child
const PrintEnqury = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const handlePrint = () => {
    window.print();
  };

  const data = props.downloadForm;
  const SignImg = props.SignImg;

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      handleDownloadPDF();
    }
  }, [data]);

  const handleDownloadPDF = () => {
    if (!data || Object.keys(data).length === 0) {
      return;
    }
    setLoading(true);
    const part1 = document.getElementById("part1");
    // const part2 = document.getElementById("part2");
    const pdf = new jsPDF("p", "mm", "a4");
    const renderPart = (element, isFirstPart) => {
      return html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: true,
        allowTaint: true,
        letterRendering: true,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 210; // A4 width in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (!isFirstPart) {
          pdf.addPage();
        }
        pdf.addImage(imgData, "PNG", 10, 10, imgWidth - 20, imgHeight - 20);
      });
    };
    renderPart(part1, true)
      .then(() => {
        pdf.save("Insurance Form.pdf");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useImperativeHandle(ref, () => ({
    handlePrint,
    handleDownloadPDF,
  }));

  return (
    <div>
      {loading && (
        <div className="loader2">
          <div className="spinner-box">
            <div className="configure-border-1">
              <div className="configure-core"></div>
            </div>
            <div className="configure-border-2">
              <div className="configure-core"></div>
            </div>
          </div>
        </div>
      )}

      <div id="pdf-content" className="Print_Enqury_contrr">
        {/**-------------------------PDF SLIDE 1--------------------------- */}
        <div className="part1" id="part1">
          <div className="FormHeading">
            <h1>Agreement of Terms and Condition for Car Rental</h1>
          </div>
          <div className="rowCLssForm">
            <div className="form-label">Name :-</div>
            <div className="form-value">
              {data?.first_name || "NA "}
              {data?.from_time || "NA "}
            </div>
          </div>
          <div className="rowCLssForm">
            <div className="form-label">Driver :-</div>
            <div className="form-value">
              {data?.first_name || "NA "}
              {data?.from_time || "NA "}
            </div>
          </div>
          <div className="rowCLssForm">
            <div className="form-label">DL :-</div>
            <div className="form-value">{data?.driving_licence || "NA "}</div>
          </div>
          <div className="rowCLssForm">
            <div className="form-label">Insurance Policy :-</div>
            <div className="form-value">{data?.insurance_policy || " "}</div>
          </div>
          <div className="rowCLssForm">
            <div className="form-label">Car :-</div>
            <div className="form-value">{data?.present_map_address || " "}</div>
          </div>{" "}
          <div className="rowCLssForm">
            <div className="form-label">LP :-</div>
            <div className="form-value">
              {data?.car_data?.length > 0 ? data.car_data[0].car_no : "NA"}
            </div>
          </div>{" "}
          <div className="rowCLssForm">
            <div className="form-label">Make Year :-</div>
            <div className="form-value">
              <div className="form-value">
                {data?.car_data?.length > 0 ? data.car_data[0].make_year : "NA"}
              </div>
            </div>
          </div>{" "}
          <div className="rowCLssForm">
            <div className="form-label">Modal :-</div>
            <div className="form-value">
              {data?.car_data?.length > 0 ? data.car_data[0].model_name : "NA"}
            </div>
          </div>{" "}
          <div className="rowCLssForm">
            <div className="form-label">VIN :-</div>
            <div className="form-value">
              {data?.car_data?.length > 0 ? data.car_data[0].vin : "NA"}
            </div>
          </div>{" "}
          <div className="rowCLssForm marginCLssEnq">
            <div className="form-value">
              The above company/owner will be lien Holder / Lessor/ additional
              interest and loss payee for the above policy. Any Refund at the
              time of cancellation or payments will be directly sent to the
              company / Owner. I the Renter will be using the car for Rideshare
              and personal use only. I am personally liable for any damage /
              deductible and any other fees or charges.
            </div>
          </div>{" "}
          <div className="col-6">
            <div className="rowCLssForm flexCol">
              <div className="form-label">Signature :-</div>
              <div className="form-value">
                {/* <p>{SignImg + data?.signature_image} </p> */}
                {data && data.signature_image > 0 && (
                  <img
                    className="SignImg"
                    src={SignImg + data.signature_image}
                  />
                )}
              </div>
            </div>{" "}
          </div>
        </div>
        {/**--------------------------part2-------------------------------- */}
        {/* <div className="part2" id="part2">


          <div className="col-6">
            <div className="rowCLssForm flexCol">
              <div className="form-label">Driving licence image :-</div>
              <div className="form-value">
                <p>{APL_LINK + data?.driving_licence_image_full}</p>
              
                <img className="SignImg" src={APL_LINK + data?.driving_licence_image_full || " "} ></img>
              </div>
            </div>{" "}
          </div>



        </div> */}
      </div>
    </div>
  );
});

export default PrintEnqury;
